import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { registerStart, registerSuccess, registerFailure, registerPrestaSuccess, updateUserData } from "../../store/slices/userSlice";
import LayoutPro from "./layoutPro";
import { toast } from "react-toastify";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useSelector } from "react-redux";
import { getMyEtablissement } from "../../store/slices/etablissementSlice";
import { format } from "date-fns";
import { Helmet, HelmetProvider } from "react-helmet-async";
const MAX_SIZE_MB = 2;
const ALLOWED_FORMATS = ["image/jpeg", "image/png"];
function PersonalInformations() {
  const location = useLocation();
  const token = location?.state?.token || localStorage.getItem('token');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedEtablissement } = useSelector((state) => state.etablissements);
  // console.log({selectedEtablissement})
  useEffect(() => {
    dispatch(getMyEtablissement());
  }, [dispatch]);

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
      'Accept': 'application/json',
    }
  };

  const validationSchema = Yup.object().shape({
    nom: Yup.string().required("Le nom est requis"),
    prenom: Yup.string().required("Le prénom est requis"),
    telephone: Yup.string()
      .required("Le numéro de téléphone est requis")
      .test("is-valid-phone", "Numéro de téléphone invalide", (value) => {
        if (!value) return false; // Required field
        return isValidPhoneNumber(value);
      }),
    dateOfBirth: Yup.date()
      .required("La date de naissance est requise")
      .max(new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
        "Vous devez avoir au moins 18 ans")
      .min(new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
        "Date de naissance invalide"),
    denomination: Yup.string().required("La dénomination est requise")
      .max(125, "Le nom de l'entreprise ne doit pas dépasser 125 caractères"),

  });

  const getInitialValues = () => {
    const userData = JSON.parse(localStorage.getItem('user')) || {};
    return {
      nom: userData?.nom || '',
      prenom: userData?.prenom || '',
      telephone: userData?.phone_number || '',

      denomination: userData?.company_name || '',
      dateOfBirth: userData?.birthday || '',

    };
  };

  useEffect(() => {
    localStorage.removeItem('stepsStatus');
  }, []);
  // Renvoie la date d'il y a 18 ans (date MAXIMUM pour avoir 18 ans aujourd'hui)
  function getMaxBirthDateFor18() {
    const today = new Date();
    const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    return formatDateToYYYYMMDD(maxDate);
  }

  // Renvoie la date d'il y a 120 ans (date MINIMUM pour éviter des âges irréalistes)
  function getMinBirthDate() {
    const today = new Date();
    const minDate = new Date(today.getFullYear() - 120, today.getMonth(), today.getDate());
    return formatDateToYYYYMMDD(minDate);
  }

  // Formate une date en 'YYYY-MM-DD' (compatible avec input[type="date"])
  function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  // Fonction debounced pour la vérification SIRET
  const checkSiret = async (value) => {
    if (!value || value.length !== 14) return false;
    try {
      const response = await fetch(`https://api.insee.fr/api-sirene/3.11/siret/${value}`, {
        headers: { 'X-INSEE-Api-Key-Integration': process.env.REACT_APP_CONSUMER_KEY }
      });
      return response.ok;
    } catch {
      return false;
    }
  };
  const handleSubmit = async (values, { setSubmitting }) => {
    // const isSiretValid = await checkSiret(values.siret);
    // if (!isSiretValid) {
    //   toast.error("Le SIRET n'existe pas dans la base INSEE");
    //   return;
    // }
    const formData = new FormData();

    // Append all existing fields
    formData.append('nom', values.nom);
    formData.append('prenom', values.prenom);
    formData.append('phone_number', values.telephone);
    // formData.append('siret', values.siret);
    formData.append('company_name', values.denomination);
    // formData.append('tva', values.tva);
    formData.append('is_professional', 1);
    formData.append('birthday', values.dateOfBirth); // Add this line

    // Append the CIN files
    // if (values.cinRecto) formData.append('identity_document_front', values.cinRecto);
    // if (values.cinVerso) formData.append('identity_document_back', values.cinVerso);
    try {
      dispatch(registerStart());
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}register/info`,
        formData,
        headers
      );

      if (response) {
        localStorage.setItem('user', JSON.stringify(response?.data?.user));
        localStorage.setItem('documents', JSON.stringify(response?.data?.processed_documents));
        const stepsStatus = JSON.parse(localStorage.getItem("stepsStatus")) || {};
        stepsStatus[1] = "completed";
        dispatch(updateUserData({ user: response?.data?.user }));
        navigate('/choiceFormula');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Échec de l'enregistrement";
      dispatch(registerFailure(errorMessage));
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={getInitialValues()}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize

    >

      {({ submitForm, isSubmitting, touched, errors, setTouched, setFieldValue, values, handleBlur }) => {
        const handleFooterSubmit = () => {
          setTouched({
            nom: true,
            prenom: true,
            telephone: true,
            denomination: true,
            dateOfBirth: true
          });
          submitForm();
        };

        return (
          <LayoutPro
            btn={false}
            currentStep={1}
            nextStep={"/choiceFormula"}
            handleSubmit={handleFooterSubmit}
            disabled={isSubmitting}
            nameBtnSubmit="Étape suivante"
          >
            <HelmetProvider>
              <Helmet>
                <title>Inscription Prestataire </title>
                <meta
                  name="description"
                  content="Inscription Prestataire étape informations perso"
                />
              </Helmet>
            </HelmetProvider>
            <div className="container">
              <div className="d-flex justify-content-center mt-48">
                <div className="col-md-6">
                  <h2>Informations personnelles</h2>

                  <Form className="register-form mt-24">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="input-wrapper">
                          <label className="form-label">Nom*</label>
                          <Field
                            name="nom"
                            placeholder="Nom"
                            className={`padding-input-text ${touched.nom && errors.nom ? "is-invalid" : ""
                              }`}
                          />
                          <ErrorMessage
                            name="nom"
                            component="div"
                            className="error-message mt-1"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="input-wrapper">
                          <label className="form-label">Prénom*</label>
                          <Field
                            name="prenom"
                            placeholder="Prénom"
                            className={`padding-input-text ${touched.prenom && errors.prenom
                                ? "is-invalid"
                                : ""
                              }`}
                          />
                          <ErrorMessage
                            name="prenom"
                            component="div"
                            className="error-message mt-1"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="input-wrapper">
                      <label className="form-label">Numéro de téléphone*</label>

                      <PhoneInput
                        excludeCountries={[]}
                        international
                        defaultCountry="FR"
                        value={values.telephone}
                        onChange={(value) => setFieldValue("telephone", value)}
                        onBlur={handleBlur}
                        id="telephone"
                        name="telephone"
                      />
                      <ErrorMessage
                        name="telephone"
                        component="div"
                        className="error-message mt-1"
                      />
                    </div>
                    <div className="input-wrapper">
                      <label className="form-label">Date de naissance*</label>
                      <Field
                        name="dateOfBirth"
                        type="date"
                        className={`padding-input-text ${touched.dateOfBirth && errors.dateOfBirth ? "is-invalid" : ""
                          }`}
                        // max={format(new Date(), 'yyyy-MM-dd')}
                        min={getMinBirthDate()}       // Il y a 120 ans (pour éviter des dates irréalistes)
                        max={getMaxBirthDateFor18()}  // Il y a 18 ans
                      />
                      <ErrorMessage
                        name="dateOfBirth"
                        component="div"
                        className="error-message mt-1"
                      />
                    </div>
                    <div className="input-wrapper">
                      <label className="form-label">
                        Dénomination de l'entreprise*
                      </label>
                      <Field
                        name="denomination"
                        placeholder="Dénomination de l'entreprise"
                        className={`padding-input-text ${touched.denomination && errors.denomination
                            ? "is-invalid"
                            : ""
                          }`}
                        maxLength={125}
                      />
                      <ErrorMessage
                        name="denomination"
                        component="div"
                        className="error-message mt-1"
                      />
                    </div>




                    <div className="h130"></div>
                  </Form>
                </div>
              </div>
            </div>
          </LayoutPro>
        );
      }}
    </Formik>
  );
}

export default PersonalInformations;
